import * as THREE from "three";

// const loader = new THREE.TextureLoader();

export const blackMaterial = new THREE.MeshStandardMaterial({
  color: "#212024",
});

export const grayMaterial = new THREE.MeshStandardMaterial({
  color: "#696969",
});

export const lightgrayMaterial = new THREE.MeshStandardMaterial({
  color: "#a6a4a4",
});

export const darkGrayMaterial = new THREE.MeshStandardMaterial({
  color: "#292929",
});

export const whiteMaterial = new THREE.MeshStandardMaterial({
  color: "#ffffff",
});

export const whiteBreakMaterial = new THREE.MeshStandardMaterial({
  color: "#cfccc8",
});

export const orangeMaterial = new THREE.MeshPhysicalMaterial({
  color: "#ff3c00",
});
export const yellowMaterial = new THREE.MeshStandardMaterial({
  color: "#f5d742",
});

export const blueMaterial = new THREE.MeshStandardMaterial({
  color: "#40bbf5",
});

export const darkBlueMaterial = new THREE.MeshStandardMaterial({
  color: "#004cbf",
});

export const greenMaterial = new THREE.MeshStandardMaterial({
  color: "#004cbf",
});

export const redMaterial = new THREE.MeshStandardMaterial({
  color: "#f56440",
});

export const metalicDarkMaterial = new THREE.MeshStandardMaterial({
  color: "#E5E5E5",
  metalness: 0.5,
  roughness: 0.5,
});

export const metalicLightMaterial = new THREE.MeshStandardMaterial({
  color: "#EDEDED",
  metalness: 0.5,
  roughness: 0.6,
});

export const woodMaterial = new THREE.MeshStandardMaterial({
  color: "#ba926a",
  shadowSide: THREE.DoubleSide,
});

export const screenMaterial = new THREE.MeshStandardMaterial({
  color: "#5b6e75",
});

export const greenTennisBall = new THREE.MeshStandardMaterial({
  color: "#bcfa2a",
});

export const cameraColor = new THREE.MeshStandardMaterial({
  color: "#7470FF",
});
export const cameraBlack = new THREE.MeshStandardMaterial({
  color: "#212024",
});

// export const cameraColor = new THREE.MeshPhysicalMaterial({
//   color: "#7470FF",
//   normalMap: loader.load("/textures/normals/camera-normal-2-paint.png"),
// });
// export const cameraBlack = new THREE.MeshPhysicalMaterial({
//   color: "#212024",
//   normalMap: loader.load("/textures/normals/camera-normal-2-paint.png"),
// });

/** CHARACTER */
export const greenShirtMaterial = new THREE.MeshStandardMaterial({
  color: "#3b6345",
});

export const skinMaterial = new THREE.MeshStandardMaterial({
  color: "#DBB387",
});
export const hairMaterial = new THREE.MeshStandardMaterial({
  color: "#b8934f",
});
